import { connect } from 'react-redux';

import { ThunkDispatch } from 'modules/shared/redux/utils/type';
import { listModule } from 'modules/shared/redux';
import { RootState } from 'modules/shared/redux/store';

import { compose } from 'redux';
import { GetBrand, Brand } from 'modules/catalogue/models';
import { brandService } from 'modules/catalogue/services';
import { WithFetchDatasByParamsFromCMSInputProps } from 'modules/shared-cms-advanced';
import { WithStatelessDatasFetchingByParameters } from 'modules/shared/hocs';
import { cacheQueryService } from 'modules/shared/services';
import { ProductOwnProps, ProductStateProps, ProductDispatchProps, BrandDataFromBoProps } from './product-type';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapStateToProps = (state: RootState, props: ProductOwnProps): ProductOwnProps & ProductStateProps => {
    const { variants } = props;
    const isAuthenticated = state && state.authentication ? !!state.authentication.loggedInFolder : false;

    if (!props || !variants || variants.length === 0) {
        return { isAuthenticated, currentElements: [], ...props };
    }

    if (
        !state ||
        !state.list ||
        !state.list.currentList ||
        !state.list.currentList.elements ||
        state.list.currentList.elements.length === 0
    ) {
        return { isAuthenticated, currentElements: [], ...props };
    }

    const currentListElements = state.list.currentList.elements
        .filter(e => e.variantId && variants.some(v => v.id === e.variantId))
        .map(e => {
            return { ...e };
        });

    return {
        isAuthenticated,
        currentElements: currentListElements || [],
        ...props,
    };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapDispatchToProps = (dispatch: ThunkDispatch<RootState>): ProductDispatchProps => ({
    updateQuantities: updatedElements => dispatch(listModule.action.updateElementsQuantity(updatedElements)),
});

const reduxConnect = connect<ProductStateProps, ProductDispatchProps, ProductOwnProps, RootState>(
    mapStateToProps,
    mapDispatchToProps,
);

const enhancer = compose<React.ComponentType<GetBrand & WithFetchDatasByParamsFromCMSInputProps>>(
    reduxConnect,
    WithStatelessDatasFetchingByParameters<Brand, BrandDataFromBoProps, GetBrand>(
        cacheQueryService.cacheWithParams('getBrand', brandService.get),
        undefined,
        'redirect',
        'brandDataFromBo',
        ['id'],
    ),
);

export default enhancer;
